import type {YearValueEditorValidations} from './types';
import type {Validator} from 'svelte-forms';
import {isDefined} from '../../../../utils/custom-utils';
import {maxYearValidator, minYearValidator, requiredValidator} from './../../shared/validators';
import {DateTime} from 'luxon';


export function validatorFactory(validations: YearValueEditorValidations): Validator[] {
    const validators: Validator[] = [];

    if (isDefined(validations.required) && validations.required) {
        validators.push(requiredValidator());
    }

    if(isDefined(validations.maxDate)) {
        validators.push(maxYearValidator(DateTime.fromFormat(validations.maxDate.toString(10), 'y').toISODate(), 'y'));
    }

    if (isDefined(validations.minDate)) {
        validators.push(minYearValidator(DateTime.fromFormat(validations.minDate.toString(10), 'y').toISODate(), 'y'));
    }

    return validators;
}


export function yearFromStringToNumberParser(): (_: string) => number {
    return (value: string) => {
        if (!value) return null;

        return parseInt(value, 10);
    }
}

export function yearFromNumberToStringFormatter() {
    return (value: number) => {
        if (!value) return null;

        return value.toString(10);
    }
}

